export default __webpack_public_path__ + "static/media/icon_pages_button_sharemore_enabled.52a939b9.svg";